import { Grid, Box, useTheme } from "@mui/material";
import { Common } from "../../../common/src";
import Project from "./parts/Project";
import { Dispatch, SetStateAction } from "react";

type PropsClustering = {
  index: string;
  displayProjects: { [name: string]: [Common.Project] };
  jobsiteList: Common.LandlogJobSite[];
  userList: Common.ProjectUserList[];
  selectProject: Common.Project[];
  setSelectProject: (project: Common.Project[]) => void;
  isLanguage: boolean;
  setErrorSnackbar: Dispatch<SetStateAction<boolean>>;
  setErrorMsg: Dispatch<SetStateAction<string>>;
  setOpenWarning: Dispatch<SetStateAction<boolean>>;
  setMsgWarning: Dispatch<SetStateAction<string>>;
  isARAvailable: boolean;
};

export const ClusteringItems = (props: PropsClustering) => {
  // key毎に分けてコンポーネントを作成する
  const displayProjects = props.displayProjects;
  let index = props.index;
  const cluster = displayProjects[index].map((project) => (
    <Project
      project={project}
      selectProject={props.selectProject}
      setSelectProject={props.setSelectProject}
      jobsiteNameList={props.jobsiteList}
      userNameList={props.userList}
      key={project.id}
      isLanguage={props.isLanguage}
      setErrorSnackbar={props.setErrorSnackbar}
      setErrorMsg={props.setErrorMsg}
      setOpenWarning={props.setOpenWarning}
      setMsgWarning={props.setMsgWarning}
      isARAvailable={props.isARAvailable}
    />
  ));

  // 日付変換
  let dateIndex = new Date(index);
  let formattedDate;

  if (props.isLanguage) {
    if (index.match(/\d{4}$/)) {
      formattedDate = dateIndex.getFullYear();
    } else if (index.match(/\d{4}\/?\d{2}$/)) {
      formattedDate =
        dateIndex.getFullYear() +
        "/" +
        ("0" + (dateIndex.getMonth() + 1)).slice(-2);
    } else if (index.match(/\d{4}\/?\d{2}\/?\d{2}$/)) {
      formattedDate =
        dateIndex.getFullYear() +
        "/" +
        ("0" + (dateIndex.getMonth() + 1)).slice(-2) +
        "/" +
        ("0" + dateIndex.getDate()).slice(-2);
    }
  } else {
    if (index.match(/\d{4}$/)) {
      formattedDate = dateIndex.getFullYear();
    } else if (index.match(/\d{4}\/?\d{2}$/)) {
      formattedDate =
        ("0" + (dateIndex.getMonth() + 1)).slice(-2) +
        "/" +
        dateIndex.getFullYear();
    } else if (index.match(/\d{4}\/?\d{2}\/?\d{2}$/)) {
      formattedDate =
        ("0" + dateIndex.getDate()).slice(-2) +
        "/" +
        ("0" + (dateIndex.getMonth() + 1)).slice(-2) +
        "/" +
        dateIndex.getFullYear();
    }
  }
  index = formattedDate.toString();

  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
  };

  return (
    <Grid container>
      <Grid container>
        <Grid item xs={12}>
          <h3 style={{ fontSize: "20px", ...customColor }}>{index}</h3>
        </Grid>
      </Grid>
      <Box sx={{ flexGrow: 1 }}>
        <Grid
          container
          spacing={{ xs: 1, md: 1 }}
          columns={{ xs: 3, sm: 8, md: 12 }}
        >
          {cluster}
        </Grid>
      </Box>
    </Grid>
  );
};
